export const REQUIRED_FIELD_MESSAGE = 'Need to fill field';
export const EMAIL_FIELD_PATTERN_MESSAGE = 'Incorrect email format';
export const IMAGE_FILE_TYPE_MESSAGE = 'Incorrect file type | accepts png, jpg, webp';
export const UPLOAD_FILE_TYPE_MESSAGE = 'Incorrect file type | accepts png, jpg, webp, pdf';
export const UPLOAD_FILE_XLSX = 'incorrect file type | accepts xlsx'
export const PASSWORD_NOT_MATCHING = 'password does not match';
export const NUMBER_PATTERN_MESSAGE = 'Invalid number';
export const MONEY_PATTERN_MESSAGE = 'Invalid price';
export const COUNTING_NUMBER_PATTERN_MESSAGE = 'Invalid number';
